/**
 * TimeAgo Component
 * Ora relativa della lista chat ("adesso", "5 min", "14:32", "ieri", "lun", "12/09"),
 * uguale su tutti i canali e aggiornata ogni minuto. Passandoci sopra si legge data e ora.
 */

import { useMinuteTick } from '@/lib/hooks/useMinuteTick';
import { chatExactTime, chatRelativeTime } from '@/lib/utils/chatTime';
import { tip } from '@/components/messages/ChatTooltip';

interface TimeAgoProps {
  timestamp: Date | number | string | null | undefined;
  hasUnread?: boolean;
  className?: string;
}

export function TimeAgo({ timestamp, hasUnread = false, className = '' }: TimeAgoProps) {
  const now = useMinuteTick();
  const label = chatRelativeTime(timestamp, now);
  if (!label) return null;

  return (
    <span
      {...tip(chatExactTime(timestamp))}
      className={`text-[11px] flex-shrink-0 ${hasUnread ? 'text-[#2383e2] font-medium' : 'text-[#a4a4a0]'} ${className}`}
    >
      {label}
    </span>
  );
}
